export const HOPDONG_LIST_INITING             = 'HOPDONG_LIST_INITING'
export const HOPDONG_LIST_REQUESTING          = 'HOPDONG_LIST_REQUESTING'
export const HOPDONG_LIST_SUCCESS             = 'HOPDONG_LIST_SUCCESS'
export const HOPDONG_LIST_ERROR               = 'HOPDONG_LIST_ERROR'   

export const HOPDONG_DETAIL_INITING           = 'HOPDONG_DETAIL_INITING'
export const HOPDONG_DETAIL_REQUESTING        = 'HOPDONG_DETAIL_REQUESTING'
export const HOPDONG_DETAIL_SUCCESS           = 'HOPDONG_DETAIL_SUCCESS'
export const HOPDONG_DETAIL_ERROR             = 'HOPDONG_DETAIL_ERROR'   

export const HOPDONG_UPDATE_REQUESTING        = 'HOPDONG_UPDATE_REQUESTING'
export const HOPDONG_UPDATE_SUCCESS           = 'HOPDONG_UPDATE_SUCCESS'
export const HOPDONG_UPDATE_ERROR             = 'HOPDONG_UPDATE_ERROR'   

export const HOPDONG_REMOVE_REQUESTING        = 'HOPDONG_REMOVE_REQUESTING'
export const HOPDONG_REMOVE_SUCCESS           = 'HOPDONG_REMOVE_SUCCESS'
export const HOPDONG_REMOVE_ERROR             = 'HOPDONG_REMOVE_ERROR' 

export const HOPDONG_DETAIL_API               = '/api/v1/hopdong/get_detail_hopdong'  
export const HOPDONG_LIST_API                 = '/api/v1/hopdong/hopdong_list_by_khachhang'   
export const HOPDONG_UPDATE_API               = '/api/v1/hopdong/update_hop_dong' 
export const HOPDONG_REMOVE_API               = '/api/v1/hopdong/hopdong_remove_by_id'


// WEBPACK FOOTER //
// ./src/views/HopDong/constants.js